import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Typography } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import Button from '~/components/Button';
import CustomizedInputs from '~/components/Input';
import { validateCode } from '~/services/modules/users';
import { useRenewalStore } from '~/store/slices/renewal';
import { Data } from '../../../interfaces/contractinfo';
import { purpleText } from '../../../styles';
import { CodeValidationRenewal } from '../../../validations';
import { sxButton, sxForm, sxMainBox } from '../styles';

import { storeState } from '~/store';

export type AuthRenewalForm = yup.InferType<typeof CodeValidationRenewal>;
interface Props {
  data: Data;
  type: number;
}
export function SendCode({ data, type }: Props) {
  const setAuthenticated = useRenewalStore((state) => state.setAuthenticated);

  const {
    control,
    handleSubmit,

    formState: { isValid }
  } = useForm<AuthRenewalForm>({
    resolver: yupResolver(CodeValidationRenewal),
    defaultValues: { code: '' },
    mode: 'onChange'
  });
  const onValidateCode = async (form: AuthRenewalForm) => {
    try {
      await validateCode(data.insured.document, form.code, type);
      setAuthenticated(true);
    } catch (e) {
      console.log(e);
      storeState.addToast({
        title: 'Erro',
        message: 'Código inválido',
        type: 'error'
      });
    }
  };
  return (
    <Box sx={sxMainBox}>
      <div>
        <Typography variant="subtitle1" sx={{ ...purpleText, textAlign: 'center' }}>
          Informe o código de autenticação
        </Typography>
      </div>

      <form onSubmit={handleSubmit(onValidateCode)} style={sxForm}>
        <div>
          <Controller
            name="code"
            control={control}
            render={({ field, fieldState }) => (
              <CustomizedInputs
                {...field}
                helperText={fieldState.error?.message}
                error={!!fieldState.error}
                isDirty={!!field.value}
                placeholder="_________"
                style={{
                  width: '13rem'
                }}
              />
            )}
          />
        </div>

        <Button disabled={!isValid} type="submit" sx={sxButton}>
          Visualizar cotação para renovar
        </Button>
      </form>
    </Box>
  );
}
